Bingo.Popup = {};

Bingo.Popup.initGallery = function (translations) {
    const options = {
        protect: true,
        idleTime: false,
    };
    const final = $.extend(true, options, translations);
    $('[data-fancybox]').fancybox(final);
};
